<div *ngIf="!view" class="grid p-fluid form">
  <div class="field col-4 md:col-4">
    <p-toggleButton
      class="input-field"
      type="username"
      aria-describedby="username1-help"
      (ngModelChange)="onInputChange1($event)"
      [(ngModel)]="model1"
      onIcon="pi pi-check"
      [disabled] = true

    >
    </p-toggleButton>
    <div class="text-title">ปกติ</div>
  </div>
  <div class="field col-4 md:col-4">
    <p-toggleButton
      class="input-field"
      type="username"
      aria-describedby="username1-help"
      (ngModelChange)="onInputChange2($event)"
      [(ngModel)]="model2"
      onIcon="pi pi-check"
      [disabled] = true

    >
    </p-toggleButton>
    <div class="text-title">เสี่ยง</div>
  </div>
  <div class="field col-4 md:col-4">
    <p-toggleButton
      class="input-field"
      type="username"
      aria-describedby="username1-help"
      (ngModelChange)="onInputChange3($event)"
      [(ngModel)]="model3"
      onIcon="pi pi-check"
      [disabled] = true
    >
    </p-toggleButton>
    <div class="text-title">มีปัญหา</div>
  </div>
  <!-- <span *ngIf="!model" class="red validateText"> โปรดระบุ </span> -->
</div>
